<template>
  <div class="page-wrapper">


    <search-group title="" @search="findData" @clear="clearValue" :span="20" :btnOffset="18" :btnSpan="6"
                  :multipleLines="false" :inline="true"
    >
      <Row class="mb16" :gutter="16" >
        <Col span="5">
          <Select v-model="searchData.projectFid" placeholder="项目名称">
            <Option value=''>请选择</Option>
            <Option v-for="(item,index) in projectList"  :value="item.value || 0" :key="'keyB'+index">{{item.text}}</Option>
          </Select>
        </Col>
        <Col span="5">
          <Select v-model="searchData.meterType" placeholder="类型">
            <Option value=''>请选择</Option>
            <Option v-for="(item,index) in typeList" :value="item.value" :key="'keyB2'+index">{{item.text}}</Option>
          </Select>
        </Col>
        <Col span="5">
          <DatePicker style="width:100%" v-model="searchData.createTime" split-panels type="daterange" format="yyyy-MM-dd"
                      placeholder="请选择日期"></DatePicker>
        </Col>
      </Row>
    </search-group >

    <table-list
      class="mt12"
      :columns="columns"
      :data="data"
      :current="current"
      :total="total"
      :loading="loading"
      @change-page="changPage"
    ></table-list>

  </div>

</template>

<script type="text/ecmascript-6">
  // import SearchGroup from 'components/SearchGroup/index';
  // import TableList from 'components/TableList/index';
  import {formatDateTime} from "../../../utils/format";
  import {mapGetters} from 'vuex'
  import {getMeterTypeList,waterwattordinaryhaveRead} from "../../../api/waterAndElectricity";


  export default {
    name:'waterelectricityrecord',
    components: {
      // SearchGroup,
      // TableList,
    },
    created(){
      getMeterTypeList().then(res=>{
        if(!res.data){
          return
        }
        this.typeList=res.data.meterType

      }).catch(error=>{})

    },
    mounted() {
      setTimeout(() => {
        this.getData()
      },501)
    },
    watch: {
      projectList(){
        this.getData()
      }
    },
    computed: {
      ...mapGetters(['projectList']),
      searchDataComputed() {
        function f(data) {
          return data ? formatDateTime(data, false) : ''
        }
        return {
          meterType:this.searchData.meterType,
          projectFids: this.searchData.projectFid ? this.searchData.projectFid : null,
          startTime: f(this.searchData.createTime[0]) || null,
          endTime:f(this.searchData.createTime[1]) || null

        }
      }
    },
    data() {
      return {
        typeList:[],
        searchParams:null,
        data: [],
        columns: [
          {
            type: 'index',
            width: 60,
            align: 'center'
          },
          {
            title: '项目名称 ',
            align: 'center',
            key: 'projectName',
            width: 120,
          },
          {
            title: '类型 ',
            align: 'center',
            key: 'meteTypeName',
            width: 130,
          },
         {
            title: "单价",
            align: 'center',
            key: 'price',
            width: 120,
            // render:(h,params)=>{
            //   return h('span',{},formatDateTime(params.row['startDate'],false))
            // }
          },
          {
            title: "上期示数",
            align: 'center',
            key: 'preMeterReading',
            width: 120,
          },

          {
            title: "上期抄表时间",
            align: 'center',
            key: 'preReadTime',
            width: 180,
            render:(h,params)=>{
              return h('span',{},formatDateTime(params.row['preReadTime'],true))
            }
          },

          {
            title: "本期示数",
            align: 'center',
            key: 'meterReading',
            width: 120,
            // render:(h,params)=>{
            //   return h('span',{},formatMoney(params.row['incomeMoney']))
            // }
          },

          {
            title: "本期抄表时间 ",
            align: 'center',
            key: 'readTime',
            width: 180,
            render:(h,params)=>{
              return h('span',{},formatDateTime(params.row['readTime'],true))
            },
          },

          {
            title: "成本金额",
            align: 'center',
            key: 'cost',
            width: 120,
            // render:(h,params)=>{
            //   return h('span',{},formatDateTime(params.row['releaseDate'],false))
            // }

          },

          {
            title: "创建人",
            align: 'center',
            key: 'lastModifyBy',
            width: 120,
            // render:(h,params)=>{
            //   return h('span',{},formatDateTime(params.row['releaseDate'],false))
            // }

          },
        ],
        total: 0,
        current: 1,
        loading: false,
        metaList:[],
        page:1,
        limit:10,
        searchData: {
          projectFid: null,
          createTime: [null, null],
          meterType: null

        },
      }
    },
    methods: {
      // getFee(){
      //   getFzFwf()
      //     .then(res=>{
      //       this.typeList = res.data;
      //     })
      // },
      getData(){
        let params={
          ...this.searchDataComputed,
          page:this.page,
          limit:this.limit
        }
        this.data=[]
        this.loading=true
        waterwattordinaryhaveRead(params).then(res=>{
          if(!res.data){
            return
          }
          this.total=res.data.total
          this.data=res.data.rows?res.data.rows:[]

        }).catch(error=>{
        }).finally(()=>{
          this.loading=false

        })

      },
      changPage(n){
        this.current = n;
        this.page = n;
        this.getData()
      },
      findData() {
        this.searchParams=this.searchDataComputed
        this.page=1
        this.current=1
        this.getData()
      },
      clearValue() {
        this.searchData = {
          projectFid: '',
          createTime: ['', ''],
          condition:''
        }
      },
    },
  }
</script>

<style scoped>
  .width3 {
    width: 200px;
  }
</style>
